import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styles from '../../../../containers/ReportClaimPage.module.scss';
import { Segment, Form, Header, Button } from 'semantic-ui-react';
import AddThirdPartyDriverModal from './AddThirdPartyDriverModal';

const ThirdPartyDrivers = ({ data, policyNumber, onChange, errors }) => {
	const onRadioChange = useCallback(
		(_, {value }) => {
			onChange({ ...data, thirdPartyDrivers: value, thirdParties: [] });
		},
		[data, onChange]
	);

	const onAddDriver = useCallback(
		(driver) => {
			onChange({ ...data, thirdParties: [...data.thirdParties, driver] });
		},
		[data, onChange]
	);

	const onDeleteDriver = useCallback(
		(i) => {
			data.thirdParties.splice(i, 1);
			onChange({ ...data, thirdParties: [...data.thirdParties] });
		},
		[data, onChange]
	);
    console.log(errors);
	return (
		<Segment>
			<div className={styles.row}>
				<div>
					<Form>
						<Form.Group inline className={styles.claimRadioGroup} >
							<label className={styles.requiredLabel}>Do you have the other driver's information?</label>
							<Form.Radio
								id="thirdPartyDriversYesBtn"
								required
								error={errors['thirdPartyDrivers'] ? true : false}
								className={styles.check}
								name='thirdPartyDrivers'
								label='Yes'
								checked={data.thirdPartyDrivers === true}
								onChange={() => onRadioChange(null, { name: 'thirdPartyDrivers', value: true })}
							/>
							
							<Form.Radio
								id="thirdPartyDriversNoBtn"
								required
                                error={errors['thirdPartyDrivers']}
								name='thirdPartyDrivers'
								label='No'
								checked={data.thirdPartyDrivers === false}
								onChange={() => onRadioChange(null, { name: 'thirdPartyDrivers', value: false })}
							/>

						</Form.Group>
					</Form>
					{data.thirdPartyDrivers && (
						<React.Fragment>
							{data.thirdParties.map((tp, i) => {
								return (
									<Segment key={i}>
										<Header>
											Third Party Driver {i + 1} - {tp.firstName} {tp.lastName}
										</Header>
										<Button onClick={onDeleteDriver} primary>
											Delete
										</Button>
									</Segment>
								);
							})}

							<AddThirdPartyDriverModal policyNumber={policyNumber} onAddDriver={onAddDriver} />
						</React.Fragment>
					)}
				</div>
			</div>
		</Segment>
	);
};

ThirdPartyDrivers.propTypes = {
	data: PropTypes.any.isRequired,
	errors: PropTypes.any.isRequired,
};

export default ThirdPartyDrivers;
